<script>
    import MultiSelect from "vue-multiselect"
    import FormPhoneInput from '../../../components/forms/FormPhoneInput.vue'
    import FormInput from '../../../components/forms/FormInput.vue'
    import DateInput from '../../../components/forms/DateInput.vue'
    import FormInputWithEyeIcon from '../../../components/forms/FormInputWithEyeIcon.vue'
    import NumberInput from "./NumberInput.vue"

    export default {
        components: {
            MultiSelect,
            FormPhoneInput,
            FormInput,
            DateInput,
            FormInputWithEyeIcon,
            NumberInput
        },
        props: {
            suffixesData: Array,
            statesData: Array,
            personalInformation: Object
        },
        data() {
            return {
            }
        },
        methods: {
            suffixDropdownCustomLabel(option) {
                return `${option.suffix}`
            },
            stateDropdownCustomLabel(option) {
                return `${option.name}`
            },
        }
    }
</script>
<template>
    <div>
        <div class="row mb-2">
            <div class="col-12 col-sm-6 col-md-4 p-2 form-group">
                <FormInput 
                    title="Full Name" 
                    v-model='personalInformation.name' 
                    :required="true" 
                    :error="personalInformation.errors.name" 
                    type="text" 
                    name="name" 
                />
            </div>
            <div class="col-12 col-sm-6 col-md-4 p-2 form-group">
                <FormInput 
                    title="Middle Initial" 
                    v-model='personalInformation.middle_initials' 
                    :required="false" 
                    :error="personalInformation.errors.middle_initials" 
                    type="text" 
                    name="middleInitial" 
                />
            </div>
            <div class="col-12 col-sm-6 col-md-4 p-2 form-group">
                <label>
                    Suffix
                </label>
                <MultiSelect 
                    v-model="personalInformation.primary_suffix"
                    :custom-label="suffixDropdownCustomLabel"
                    :select-label="''"
                    :options="suffixesData"
                    track-by="id"
                    placeholder="Select Suffix"
                    :class="{
                        'is-invalid': personalInformation.errors.primary_suffix
                    }"
                >
                </MultiSelect>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12 col-sm-6 col-md-4 p-2 form-group">
                <FormInput 
                    title="Home Address (Number and Street)" 
                    v-model='personalInformation.home_address' 
                    :required="true" 
                    :error="personalInformation.errors.home_address" 
                    type="text" 
                    name="homeAddress" 
                />
            </div>
            <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
                <FormInput 
                    title="Apt" 
                    v-model='personalInformation.apt_no' 
                    :required="false" 
                    :error="personalInformation.errors.apt_no" 
                    type="text" 
                    name="apartment" 
                />
            </div>
            <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
                <label>State
                    <span class="text-danger">*</span>
                </label>
                <MultiSelect 
                    v-model="personalInformation.state"
                    :custom-label="stateDropdownCustomLabel"
                    :select-label="''"
                    :options="statesData"
                    track-by="id"
                    placeholder="Select State"
                    :class="{
                        'is-invalid': personalInformation.errors.state
                    }"
                >
                </MultiSelect>
                <div
                    v-if="personalInformation.errors.state"
                    class="text-danger"
                    style="font-size: 80%;"
                >
                    {{ personalInformation.errors.state }}
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
                <FormInput 
                    title="City" 
                    v-model='personalInformation.city' 
                    :required="true" 
                    :error="personalInformation.errors.city" 
                    type="text" 
                    name="city" 
                />
            </div>
            <div class="col-12 col-sm-12 col-md-2 p-2 form-group">
                <NumberInput 
                    title="Zip Code"
                    placeholder="Zip Code"
                    v-model='personalInformation.zipcode'
                    :required="true" 
                    :error="personalInformation.errors.zipcode"
                    :maximumlength="5"
                />
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12 col-sm-6 col-md-3 p-2 form-group">
                <DateInput 
                    title="Date of Birth (MM-DD-YYYY)" 
                    v-model='personalInformation.primary_dob' 
                    :required="true" 
                    :error="personalInformation.errors.primary_dob" 
                    :disabledDate="(date) => date >= new Date()" 
                />
            </div>
            <div class="col-12 col-sm-6 col-md-3 p-2 form-group">
                <NumberInput 
                    title="Social Security Number or ITIN"
                    placeholder="SSN or ITIN"
                    v-model='personalInformation.your_security_number'
                    :required="false" 
                    :error="personalInformation.errors.your_security_number"
                    :maximumlength="9"
                />
            </div>
            <div class="col-12 col-sm-12 col-md-3 p-2 form-group">
                <FormInput 
                    title="Email" 
                    v-model='personalInformation.email'
                    :required="true" 
                    :error="personalInformation.errors.email" 
                    type="text" 
                    name="email" 
                />
            </div>
            <div class="col-12 col-sm-12 col-md-3 p-2 form-group">
                <FormPhoneInput 
                    title="Phone" 
                    :model='personalInformation.phone' 
                    :required="false"
                    :error="personalInformation.errors.phone" 
                    type="text" 
                    name="phone" 
                    @phoneFormatted="personalInformation.phone = $event" />
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12 col-sm-12 col-md-6 p-2 form-group">
                <FormInputWithEyeIcon 
                    title="Password"
                    placeholder="Password"
                    v-model='personalInformation.password'
                    :required="true" 
                    :error="personalInformation.errors.password"
                />
            </div>
            <div class="col-12 col-sm-12 col-md-6 p-2 form-group">
                <FormInput 
                    title="Confirm Password"
                    v-model='personalInformation.password_confirmation'
                    :required="true" 
                    :error="personalInformation.errors.password_confirmation" 
                    type="password" 
                    name="confirmPassword" 
                />
            </div>
        </div>
    </div>
</template>